import { Card, CardContent } from "@repo/ui";
import { Link } from "react-router-dom";

import { Container } from "@/components/container";

export default function Services() {
  const items = [
    {
      to: "/services/it-strategy-roadmapping",
      title: "IT Strategy & Roadmapping",
      desc: "Align tech to business goals with clear priorities and budgets.",
    },
    {
      to: "/services/cloud-migration",
      title: "Cloud Migration",
      desc: "Plan and execute smooth migrations to AWS, Azure, or GCP.",
    },
    {
      to: "/services/infrastructure-networking",
      title: "Infrastructure & Networking",
      desc: "Secure, reliable networks and infrastructure (on‑prem and cloud).",
    },
    {
      to: "/services/devops-automation",
      title: "DevOps & Automation",
      desc: "CI/CD, IaC, monitoring, and SRE practices for reliability.",
    },
  ];
  return (
    <div>
      <section className="bg-secondary/50 border-b">
        <Container className="py-12 md:py-16">
          <h1 className="text-3xl md:text-4xl font-semibold">Services</h1>
          <p className="mt-3 text-muted-foreground max-w-2xl">
            Outcome-focused consulting for Bangkok SMBs. Clear deliverables, predictable timelines.
          </p>
        </Container>
      </section>
      <Container className="py-12 md:py-16 grid gap-6 md:grid-cols-2">
        {items.map((s) => (
          <Link key={s.to} to={s.to}>
            <Card>
              <CardContent className="p-6">
                <div className="font-medium mb-1">{s.title}</div>
                <p className="text-sm text-muted-foreground">{s.desc}</p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </Container>
    </div>
  );
}
